import type { AssetType, ProcedureInitiative, ProcedureType, Stored, User } from "@overmap-ai/common"

import { AssetTypeFilterDef } from "../defs/AssetTypeFilterDef"
import { CreatedByFilterDef } from "../defs/CreatedByFilterDef"
import { ProcedureTypeFilterDef } from "../defs/ProcedureTypeFilterDef"
import { SubmittedAtFilterDef } from "../defs/SubmittedAtFilterDef"
import { FilterSchema } from "./FilterSchema"
import { createFilterDefConfig } from "./utils"

interface ProcedureInitiativeFilterSchemaConfig {
	procedureTypes: Stored<ProcedureType>[]
	assetTypes: Stored<AssetType>[]
	users: User[]
}

export const getProcedureInitiativeFilterSchema = (config: ProcedureInitiativeFilterSchemaConfig) => {
	const { procedureTypes, assetTypes, users } = config

	return FilterSchema.create<Stored<ProcedureInitiative>>({
		filterDefs: [
			createFilterDefConfig({
				filterDef: new CreatedByFilterDef(users),
				accessorFn: ({ created_by }) => created_by ?? -1,
			}),
			createFilterDefConfig({
				filterDef: new SubmittedAtFilterDef(),
				accessorFn: ({ submitted_at }) => new Date(submitted_at),
			}),
			createFilterDefConfig({
				filterDef: new ProcedureTypeFilterDef(procedureTypes),
				accessorFn: ({ procedure_type }) => procedure_type,
			}),
			createFilterDefConfig({
				filterDef: new AssetTypeFilterDef(assetTypes),
				accessorFn: ({ asset_type }) => asset_type,
			}),
		],
	})
}
